
import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const discover = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1,
  type: 'Image1x1',
  associationType: 'SquareImageMedia',
  stringKey: 'ImageExperience_Image_Ratio_1x1',
  simplifiedType: 'Image1x1',
  isRequired: true,
  imagePreviewHeight: 250,
  minimumRequirements: 0,
  minSize: [300, 300],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Discover card'),
    stringKey: _TL_('Discover card'),
  },
  previewSettings: {
    previewContentClassName: 'boost-discover-card',
    showShortHeadline: true,
    showLongHeadline: false,
    showBusinessName: false,
    multipleDescription: true,
    showDescription: true,
    showAction: true,
    showImage: true,
    showBoostDiscover: true,
  },
  styleOverrides: {
    cardParent: {
      '& .responsive-ad-preview-content': {
        overflow: 'visible !important',
        width: '280px !important',
        height: 400,
        borderRadius: 5,
        border: '1px solid #C8C8C8',
        padding: '10px',
        position: 'relative !important',
      },
      '& .hardcode-discover': {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        fontSize: 16,
        color: 'black',
        borderBottom: '1px solid #C8C8C8',
        paddingLeft: 10,
      },
      '& .image-container': {
        top: 27,
        position: 'absolute',
      },
      '& .short-headline': {
        left: 15,
        top: 288,
        position: 'absolute',
        width: 250,
        fontSize: 12,
        fontWeight: 'bold',
        color: 'black',
      },
      '& .description': {
        left: 15,
        top: 310,
        fontSize: 12,
        position: 'absolute',
        color: 'black',
      },
      '& .action-button': {
        position: 'absolute',
        left: 15,
        top: 353,
        border: 'none',
        borderRadius: '0px !important',
      },
    },
  },
};

export default discover;
